import { render, staticRenderFns } from "./wrong-answer-card.vue?vue&type=template&id=41ab477f&scoped=true"
import script from "./wrong-answer-card.vue?vue&type=script&lang=js"
export * from "./wrong-answer-card.vue?vue&type=script&lang=js"
import style0 from "./wrong-answer-card.vue?vue&type=style&index=0&id=41ab477f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ab477f",
  null
  
)

export default component.exports